import { Box } from '@mui/material';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import { some } from 'lodash';
import { BottomTab, NavBar, Notifications, useGtmTrackPageView } from '../components';

const RootLayout = () => {
  useGtmTrackPageView((location) => {
    const tagManagerArgs = {
      dataLayer: {
        event: 'pageview',
        page: location.pathname,
      },
    };
    return tagManagerArgs;
  });
  const location = useLocation();

  // Paths to show bottom tab: /jobs, /jobs/:id, /jobs/period_jobs/:id, /job_hirings, /attendances
  const BOTTOM_TAB_PATHS = [
    '/jobs',
    '/jobs/:id',
    '/jobs/period_jobs/:id',
    '/job_hirings',
    '/attendances',
    '/attendances/:id',
  ];
  const showBottomTab = some(BOTTOM_TAB_PATHS, (pattern) => matchPath(pattern, location.pathname));

  return (
    <Box display="flex" height="100svh" flexDirection="column">
      <NavBar />
      <Outlet />

      {showBottomTab ? <BottomTab location={location} /> : null}

      <Notifications />
    </Box>
  );
};

export default RootLayout;
